module.exports = __webpack_public_path__ + "static/media/hebebühne_antwort2.872472b6.jpg";